export default __webpack_public_path__ + "static/media/mining.45003a45.gif";